import {IOrderDTO} from "@/interface/data-objects/order-DTO.interface"
import {OrderStatusTypeEnum, OrderTypeEnum} from "@/enums/"

export class Order {
    contractId: number;
    orderDate: Date;
    orderId: string;
    orderType: string;
    resourceName: string | null;
    oldValue: string | null;
    newValue: string | null;
    status: string;
    isCancellable: boolean;
    executedAt: Date | null;
    createdAt: Date;

    constructor(base?: Partial<Order>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    public static fromDto(dto: IOrderDTO) {
        return new Order({
            contractId: dto.contract_id,
            orderDate: new Date(dto.order_date),
            orderId: dto.order_id,
            orderType: OrderTypeEnum[dto.order_type],
            resourceName: dto.resource_name,
            newValue: dto.new_value,
            status:  OrderStatusTypeEnum[dto.status],
            isCancellable: !!dto.isCancellable,
            executedAt: dto.executedAt ? new Date(dto.executedAt) : null,
            createdAt: new Date(dto.createdAt)
        });
    }
}
